import type { I18nDictionaryShape } from '../../types';
import type { commonEnGb } from '../en-GB/common';

export const commonEsEs = {
  brand: {
    logoAlt: 'Logotipo de Safi',
    name: 'Safi',
    vatLabel: 'IVA de Safi',
  },
  currencySelectField: {
    groups: {
      other: 'Otras',
      suggested: 'Sugeridas',
    },
  },
  domains: {
    evidence: 'Evidencia',
    evidenceLower: 'evidencia',
    qualityControl: 'Control de calidad',
    qualityControlLower: 'control de calidad',
  },
  values: {
    emptyValue: '-',
  },
} satisfies I18nDictionaryShape<typeof commonEnGb>;
